<template>
    <div class="NewReferral container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Add New Helpline Call / Inquiry" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Program:</label>
                                <select class="form-control" v-model="SelectedSubProgram" @change="OnSubProgramChange" required>
                                    <option v-for="option in SubProgramOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group" v-show="SelectedSubProgram">
                                <label>Territory:</label>
                                <select v-model="TargetRecord.SubProgramTerritoryID" required class="form-control">
                                    <option v-for="option in SubProgramTerritoryOptions" :value="option.value">{{option.text}}</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="TargetRecord.SubProgramTerritoryID && SelectedSubProgram">
                        <b-col>
                            <h3>Link to Existing Community Family:</h3>
                            <v-select :options="CommunityFamilyOptions" label="text" :reduce="option => option.value" v-model="ExistingCommunityFamilyID"></v-select>
                        </b-col>
                    </b-row>
                    <div v-if="ExistingCommunityFamilyID == 'NEW'" style="margin-top:25px;">
                        <b-row>
                            <b-col>
                                <h4>NEW Family Info</h4>
                                <p><i class="fa fa-exclamation red" /> Before creating a new Community Family record, please check the existing family list (above) to ensure that this family isn't already in our database systems.  This will help prevent duplicate records.</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Parent FIRST Name:</label>
                                    <input v-model="TargetRecord.ParentNameFirst" required class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label>Parent LAST Name:</label>
                                    <input v-model="TargetRecord.ParentNameLast" required class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label>DOB:</label>
                                    <flat-pickr v-model="TargetRecord.DOB" class="form-control" :config="DateConfig" required></flat-pickr>
                                </div>
                                <div class="form-group">
                                    <label>Primary Language: [<span class="link-like" @click="AddLanguage('English')">English</span> / <span class="link-like" @click="AddLanguage('Spanish')">Spanish</span>]</label>
                                    <input v-model="TargetRecord.Language" class="form-control" />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <label>Phone Number:</label>
                                    <input v-model="TargetRecord.Phone" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label>Email:</label>
                                    <input v-model="TargetRecord.Email" class="form-control" />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h4>Address</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Physical Address:</label>
                                    <input type="text" v-model="TargetRecord.PhysicalAddressLine1" class="form-control" placeholder="Address Line 1" />
                                    <input type="text" v-model="TargetRecord.PhysicalAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                    <b-row>
                                        <div class="col-5 no-padding">
                                            <input type="text" v-model="TargetRecord.PhysicalCity" class="form-control" placeholder="City" />
                                        </div>
                                        <div class="col-3 no-padding">
                                            <select class="form-control" v-model="TargetRecord.PhysicalStateAbbreviation">
                                                <option v-for="option in StateOptions" :value="option.value">
                                                    {{option.text}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-4 no-padding">
                                            <input type="text" v-model="TargetRecord.PhysicalZipCode" class="form-control" placeholder="Zip" />
                                        </div>
                                    </b-row>
                                    <div class="form-group">
                                        <label>County:</label>
                                        <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="TargetRecord.County" required></v-select>
                                    </div>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <label>Mailing Address: <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress()" class="pointer" /></label>
                                    <input type="text" v-model="TargetRecord.MailingAddressLine1" class="form-control" placeholder="Address Line 1" />
                                    <input type="text" v-model="TargetRecord.MailingAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                    <b-row>
                                        <div class="col-5 no-padding">
                                            <input type="text" v-model="TargetRecord.MailingCity" class="form-control" placeholder="City"  />
                                        </div>
                                        <div class="col-3 no-padding">
                                            <select class="form-control" v-model="TargetRecord.MailingStateAbbreviation" >
                                                <option v-for="option in StateOptions" :value="option.value">
                                                    {{option.text}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-4 no-padding">
                                            <input type="text" v-model="TargetRecord.MailingZipCode" class="form-control" placeholder="Zip" />
                                        </div>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="ExistingCommunityFamilyID != null">
                        <b-row>
                            <b-col>
                                <h4>Inquiry Info</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Date and Time of Helpline Call / Inquiry:</label>
                                    <flat-pickr v-model="TargetRecord.InquiryDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                                </div>
                                <div class="form-group">
                                    <label>Inquiry Type:</label>
                                    <select v-model="TargetRecord.InquiryType" class="form-control" required>
                                        <option value=""></option>
                                        <option value="Helpline Call">Helpline Call</option>
                                        <option value="Walk-In">Walk-In</option>
                                        <option value="Email">Email</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Referral Source:</label>
                                    <input type="text" v-model="TargetRecord.ReferralSource" class="form-control" required />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <label>Currently Experiencing Homelessness?</label>
                                    <select v-model="TargetRecord.Homelessness" class="form-control" required>
                                        <option value=""></option>
                                        <option :value="false">No</option>
                                        <option :value="true">Yes</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Urgency of Assistance Needed?</label>
                                    <select v-model="TargetRecord.Urgency" class="form-control" required>
                                        <option value=""></option>
                                        <option value="Urgent - Need help now">Urgent - Need help now</option>
                                        <option value="Within the next week">Within the next week</option>
                                        <option value="Within the next month">Within the next month</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Number of Children who Need Asssitance?</label>
                                    <input type="number" v-model="TargetRecord.NumberOfChildrenWhoNeedAssistance" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>Reason for Assistance / Comments / Summary:</label>
                                    <textarea rows="6" v-model="TargetRecord.InquiryComments" class="form-control"></textarea>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    
                    
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import SelectFromEndpoint from '../../../Core/CustomInputElements/SelectFromEndpoint.vue';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    
    export default {
        name: "NewReferral",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                CommunityFamilyOptions: [],
                ExistingCommunityFamilyID: null,
                SelectedSubProgram: null,
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                DateTimeConfig: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y h:i K',
                },
                TargetRecord: {}
            };
        },
        methods: {
            //API
            GetCommunityFamilyOptions() {
                this.$MasterAPI.ExecuteRequest("GET", "PostAdopt/CommunityFamilies/Options", { SubProgramID: this.SelectedSubProgram }, this.GetCommunityFamilyOptionsSuccess, () => { }, true);
            },
            GetCommunityFamilyOptionsSuccess(response) {
                let opts = [
                    {
                        text: "CREATE NEW COMMUNITY FAMILY",
                        value: "NEW"
                    }
                ]
                response.data.data.forEach(function (opt) {
                    opts.push(opt);
                });
                this.CommunityFamilyOptions = opts;
            },
            SaveRecord(e) {
                e.preventDefault();
                if (this.ExistingCommunityFamilyID != "NEW") {
                    this.TargetRecord.ExistingCommunityFamilyID = this.ExistingCommunityFamilyID;
                }
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Referrals", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                this.$emit("updatetable");
                this.HideModal();
            },
            //UI
            OnSubProgramChange() {
                this.ExistingCommunityFamilyID = null;
                this.GetCommunityFamilyOptions();
            },
            ShowModal() {
                this.TargetRecord = {};
                this.CommunityFamilyOptions = [];
                this.ExistingCommunityFamilyID = null;
                this.SelectedSubProgram = null;
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            CopyPhysicalAddress() {
                this.TargetRecord.MailingAddressLine1 = this.TargetRecord.PhysicalAddressLine1;
                this.TargetRecord.MailingAddressLine2 = this.TargetRecord.PhysicalAddressLine2;
                this.TargetRecord.MailingCity = this.TargetRecord.PhysicalCity;
                this.TargetRecord.MailingStateAbbreviation = this.TargetRecord.PhysicalStateAbbreviation
                this.TargetRecord.MailingZipCode = this.TargetRecord.PhysicalZipCode;
                this.$forceUpdate();
            },
            AddLanguage(lang) {
                this.TargetRecord.Language = lang;
                this.$forceUpdate();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect,
            SelectFromEndpoint
        },
        computed: {
            StateOptions: function () {
                return [
                    {
                        text: "California",
                        value: "CA"
                    },
                    {
                        text: "Nevada",
                        value: "NV"
                    },
                    {
                        text: "Washington",
                        value: "WA"
                    }
                ];
                
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>
</style>